<template>
  <v-form>
    <h2 class="font font--h2-2 h2 mb-4">Приглашайте клиентов и получайте вознаграждение!</h2>
    <template>
      <div class="font link-read">
        <span v-if="!!type && !!reward_type">
          Мы заплатим
          <template v-if="reward_type === 'RevShare'">
            <span v-if="isUL">
              2000 руб. за каждого приведённого клиента + до 13% от его комиссии пока он не закроет счёт. При
              привлечении новых партнёров до 7% от комиссий их клиентов.
            </span>
            <span v-if="isFL">
              1600 руб. за каждого приведённого клиента + до 10% от его комиссии пока он не закроет счёт. При
              привлечении новых партнёров до 5,5% от комиссий их клиентов.
            </span>{{ " " }}
          </template>
          <span v-else>
          от {{ bonus.newPartnerFrom }} р до {{ bonus.newPartnerTo }} р за каждого клиента, открывшего счет в нашем банке,
              доплатим {{ bonus.activationCost }} р если он станет активным, а еще более
            {{ bonus.additionalServicesCost }} р можно заработать, подключая дополнительные опции вашим клиентам.При
            привлечении новых партнеров до {{ bonus.childPartnerCost }} р за их клиентов открывших счет.{{ " " }}
          </span>
          <span>
          <a class="font" target="_blank" href="https://modulbank.ru/fs/files/tarrifs_modulpartner.pdf">Ознакомиться</a>
            с полным описанием моделей вознаграждения.
          </span>
        </span>
      </div>
    </template>
    <p class="font font--color_light">Ваша реферальная ссылка на РКО:</p>
    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          class="mb-5"
          :value="referral_landing_url"
          outlined
          dense
          v-bind="attrs"
          v-on="on"
          style="height: 44px; width: 357px"
          @click="copy(referral_landing_url)"
          @mouseout="tooltipText = 'Кликните, чтобы скопировать ссылку'"
        ></v-text-field>
      </template>
      <span>{{ tooltipText }}</span>
    </v-tooltip>

    <p class="font font--color_light">Ваша реферальная ссылка на Маркетплейс:</p>
    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          class="mb-5"
          v-model="reflinkMrpl"
          outlined
          dense
          v-bind="attrs"
          v-on="on"
          style="height: 44px; width: 357px"
          @click="copy(reflinkMrpl)"
          @mouseout="tooltipText = 'Кликните, чтобы скопировать ссылку'"
        ></v-text-field>
      </template>
      <span>{{ tooltipText }}</span>
    </v-tooltip>

    <p class="font font--color_light">Ваша реферальная ссылка на МодульБухгалтерию:</p>
    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          v-model="reflinkBuh"
          outlined
          dense
          v-bind="attrs"
          v-on="on"
          style="height: 44px; width: 357px"
          @click="copy(reflinkBuh)"
          @mouseout="tooltipText = 'Кликните, чтобы скопировать ссылку'"
        ></v-text-field>
      </template>
      <span>{{ tooltipText }}</span>
    </v-tooltip>
  </v-form>
</template>
<script>
import { mapGetters, mapState } from "vuex";

export default {
  data() {
    return {
      tooltipText: "Кликните, чтобы скопировать ссылку",
    };
  },
  methods: {
    copy(link) {
      if (navigator.clipboard != undefined) {
        //Chrome
        navigator.clipboard.writeText(link).then(
          function() {
          },
          function(err) {
            console.error("Не удолось скопировать ссылку ", err);
          },
        );
      } else if (window.clipboardData) {
        // Internet Explorer
        window.clipboardData.setData("Text", link);
      }
      this.tooltipText = "Скопировано";
    },
  },
  computed: {
    ...mapState("profile", ["referral_landing_url", "type", "reward_type"]),
    ...mapGetters("profile", ["isUL", "isFL"]),
    bonus() {
      if (this.isFL) return {
          newPartnerFrom: "2300",
          newPartnerTo: "3200",
          activationCost: "700",
          additionalServicesCost: "30 000",
          childPartnerCost: "1500",
        };
      return {
        newPartnerFrom: "3000",
        newPartnerTo: "4000",
        activationCost: "1000",
        additionalServicesCost: "30 000",
        childPartnerCost: "2000",
      };
    },
    reflinkMrpl: {
      get() {
        return `https://modulbank.ru/marketplace/?utm_source=agentnet&utm_medium=partner&utm_campaign=RKO_ag-${this.$store.getters["profile/inn"]}`;
      },
      set() {
        return;
      },
    },
    reflinkBuh: {
      get() {
        return `https://modulbuh.ru/?utm_source=agentnet&utm_medium=partner&utm_campaign=RKO_ag-${this.$store.getters["profile/inn"]}`;
      },
      set() {
        return;
      },
    },
  },
};
</script>
<style scoped>
.form {
  flex-direction: column;
  display: flex;
}

.link-read {
  margin-bottom: 2rem;
}

.v-tooltip__content {
  background: #464c59;
}
</style>
